import { render, staticRenderFns } from "./VBaseCard.vue?vue&type=template&id=78540227"
import script from "./VBaseCard.vue?vue&type=script&lang=js"
export * from "./VBaseCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports